module.exports = "../fonts/hotel_transfer_icon.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hotel_transfer_icon.svg
// module id = 444
// module chunks = 0